module.exports = __webpack_public_path__ + "static/img/logo-text.e17b7302.svg";